// Return the users browser language
const browserLang = () => {
    let userLang = navigator.language || navigator.userLanguage;

    const langDelUsuario = userLang.substring(0, 2)

    switch(langDelUsuario) {
        case "en":
            return "en"
        case "de":
            return "de"
        default: 
            return "bg"
    }
}

export default browserLang